<template>
<v-main>
  <v-layout justify-center class="mt-2">
    <v-card width="1200" class="rounded-xl">

      <h1>
        <p class="text-center font-weight-bold">Alterar senha </p>
        <!-- {{recepcionista}} -->
      </h1>
      <v-form v-model="valid" ref="form" class="mx-4">

        <v-text-field v-model="senhaAtual" :append-icon="show1 ? 'visibility' : 'visibility_off'" :rules="senhaRules" :type="show1 ? 'text' : 'password'" name="input-10-1" label="Senha atual" counter @click:append="show1 = !show1"></v-text-field>
        <v-text-field v-model="novaSenha" :append-icon="show2 ? 'visibility' : 'visibility_off'" :rules="senhaRules" :type="show2 ? 'text' : 'password'" name="input-10-1" label="Nova senha" counter @click:append="show2 = !show2"></v-text-field>

        <v-checkbox label="Você concorda?" v-model="checkbox" :rules="[(v) => !!v || 'Você deve concorda para alterar']" required></v-checkbox>
        <v-alert :value="erroEditar" color="error" icon="warning" outlined>
          Senha atual incorreta !!
        </v-alert>

        <v-alert :value="sucessoEditar" color="success" icon="check_circle" outlined>
          Sucesso ao editar senha !!
        </v-alert>
      </v-form>
      <v-card-actions>
        <v-spacer />
        <v-btn rounded dark @click="submit" :class="{ red: !valid, green: valid }">Salvar</v-btn>
        <v-btn text @click="$router.go(-1)">
          <v-icon left>keyboard_backspace</v-icon>
          voltar
        </v-btn>
      </v-card-actions>
    </v-card>
  </v-layout>
</v-main>
</template>

<script>
import Cookies from 'js-cookie'
import administradorService from '../../../services/administrador.service'

export default {
  name: 'editarAdministrador',
  data() {
    return {
      senhaAtual: '',
      retornoServidor: '',
      erroEditar: false,
      sucessoEditar: false,
      erroAlterarSenha: 'false',
      novaSenha: '',
      show1: false,
      show2: false,
      valid: false,
      name: 'Default',
      nameRules: [
        (v) => !!v || 'Name is required',
        (v) => v && v.length <= 10 || 'Name must be less than 10 characters'
      ],
      senhaRules: [
        (v) => v && v.length > 5 || 'Senha deve 6 ou mais caracteres'
      ],
      email: '',
      emailRules: [
        (v) => !!v || 'E-mail is required',
        (v) => /^\w+([\.-]?\w+)*@\w+([\.-]?\w+)*(\.\w{2,3})+$/.test(v) || 'E-mail must be valid'
      ],
      select: null,
      items: [
        'Item 1',
        'Item 2',
        'Item 3',
        'Item 4'
      ],
      checkbox: false
    }
  },
  methods: {
    submit() {
      this.$refs.form.validate()
      if (this.$refs.form.validate()) {
        this.erroEditar = false
        this.sucessoEditar = false
        console.log('for editar adm..')
        console.log(this.user)

        administradorService.administrador
          .alterarSenha(this.senhaAtual, this.novaSenha, this.user.tipo, this.user.username)
          .then(rsp => {
            console.log('rsp oi:')
            console.log(rsp.data)
            if (rsp.data == 'senhaAtualIncorreta') {
              this.erroEditar = true
            }
            if (rsp.data == true) {
              this.sucessoEditar = true
              this.clear()
            }
            // console.log(this.listaChamadas);
            // this.servicoTeste = rsp.data
          })
          .catch(err => {
            // handle your error here
            console.log(err)
          })
      }
    },
    clear() {
      this.$refs.form.reset()
    }
  },

  mounted() {
    this.user = this.$store.getters.usuario
  }

}
</script>
